import React, { useState } from 'react';
import useAuthStore from '../stores/authStore';
import './AuthForm.css'; // Импортируем стили

function AuthForm() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const login = useAuthStore(state => state.login);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const endpoint = isLogin ? '/auth/token' : '/auth/register';
      
      // Разные форматы данных для логина и регистрации
      let body;
      let headers;
      
      if (isLogin) {
        // Для логина используем FormData
        const formData = new FormData();
        formData.append('username', email);  // Важно! Именно username, не email
        formData.append('password', password);
        body = formData;
        // Не указываем Content-Type, браузер сам установит правильный с boundary
        headers = {};
      } else {
        // Для регистрации используем JSON
        body = JSON.stringify({ email, password });
        headers = {
          'Content-Type': 'application/json',
        };
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
        method: 'POST',
        headers: headers,
        body: body,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Произошла ошибка');
      }

      if (isLogin) {
        // Используем функцию login из authStore вместо прямой работы с localStorage
        login(data.access_token);
        // Перенаправление теперь происходит внутри функции login в authStore
      } else {
        // После успешной регистрации автоматически логиним пользователя
        login(data.access_token);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="authform__container">
      <div className="authform__header">
        <h1>{isLogin ? 'Вход в систему' : 'Регистрация'}</h1>
      </div>
      
      {error && <div className="authform__error">{error}</div>}
      
      <form className="authform__form" onSubmit={handleSubmit}>
        <div className="authform__group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        
        <div className="authform__group">
          <label htmlFor="password">Пароль</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        
        { !isLogin && (
          <div className="authform__checkbox">
            <input
              type="checkbox"
              id="acceptTerms"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <label htmlFor="acceptTerms">
              Я принимаю{' '}
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                пользовательское соглашение
              </a>
            </label>
          </div>
        ) }

        <button
          type="submit"
          className="authform__button"
          disabled={!isLogin && !acceptedTerms}
        >
          {isLogin ? 'Войти' : 'Зарегистрироваться'}
        </button>
      </form>
      
      <div className="authform__switch">
        {isLogin ? (
          <>
            Нет аккаунта?{' '}
            <button onClick={() => setIsLogin(false)}>
              Зарегистрироваться
            </button>
          </>
        ) : (
          <>
            Уже есть аккаунт?{' '}
            <button onClick={() => setIsLogin(true)}>
              Войти
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthForm; 
